'use client'

// src/utils/addons.ts
var groupAddonsByGroupName = (addons) => {
  var _a;
  const grouped = {};
  for (let i = 0; i < addons.length; i++) {
    const addon = addons[i];
    const key = ((_a = addon == null ? void 0 : addon.addon_groups) == null ? void 0 : _a._id) || "";
    if (!(addon == null ? void 0 : addon.addon_groups))
      continue;
    if (grouped[key]) {
      grouped[key].push(addon);
    } else {
      grouped[key] = [addon];
    }
  }
  return grouped;
};
var getActualProductPrice = (product, variation) => {
  if (variation) {
    return Number(variation._sale_price || variation._price || variation._regular_price || 0);
  }
  return Number(product._sale_price || product._price || product._regular_price || 0);
};
var getOriginalProductPrice = (product, variation) => {
  if (variation) {
    return Number(variation._regular_price);
  }
  return Number(product._regular_price);
};

export {
  groupAddonsByGroupName,
  getActualProductPrice,
  getOriginalProductPrice
};
//# sourceMappingURL=chunk-6NSJHEQW.mjs.map